import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../shared';
import { RouterModule } from '@angular/router';
import { HighDensityComponent } from './high-density.component';
import { HIGH_DENSITY_ROUTES } from './high-density.route';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild(HIGH_DENSITY_ROUTES)
    ],
    declarations: [
        HighDensityComponent
    ]
})
export class HighDensityModule {}
